import { Button, TableCell, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Status } from 'src/components/atoms/status';
import { SpaceUnavailabilityState } from 'src/features/spaces/api/types/response/space.response';
import { spaceStateColors } from 'src/features/spaces/constants/space-state/space-state-colors';
import { spaceStateTranslations } from 'src/features/spaces/constants/space-state/space-state-translations';
import { spaceTypesTranslations } from 'src/features/spaces/constants/space-types-translations';
import { SpaceType } from 'src/features/spaces/types/space-type';
import { getSpaceCurrentState } from 'src/features/spaces/utils/get-space-current-state';

export interface SpacesActionsSlotPayload {
  token: string;
  name: string;
}

interface Props {
  token: string;
  name: string;
  type: SpaceType;
  floor: number;
  spaceUnavailabilityStates: SpaceUnavailabilityState[];
  onRemoveFromGroup: (spaceToken: string) => void;
}

export const SpacesTableRow = ({
  token,
  name,
  type,
  floor,
  spaceUnavailabilityStates,
  onRemoveFromGroup,
}: Props) => {
  const { t } = useTranslation(['spaces', 'spaceGroups']);

  return (
    <TableRow>
      <TableCell>
        <Typography variant="inherit">{name}</Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body2">{floor}</Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body2">
          {t(spaceTypesTranslations[type])}
        </Typography>
      </TableCell>

      <TableCell>
        <Status
          color={
            spaceStateColors[getSpaceCurrentState(spaceUnavailabilityStates)]
          }
          label={t(
            spaceStateTranslations[
              getSpaceCurrentState(spaceUnavailabilityStates)
            ],
          )}
        />
      </TableCell>

      <TableCell>
        <Button variant="outlined" onClick={() => onRemoveFromGroup(token)}>
          {t('spaceGroups:details.remove')}
        </Button>
      </TableCell>
    </TableRow>
  );
};
